(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const printButton = event.target.closest('[data-print-article]');
    if (!printButton) return;
    window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
(() => {
  const syncViews = () => document.querySelectorAll('.gridlist-toggle [data-type]').forEach((control) => {
    control.setAttribute('aria-pressed', String(control.classList.contains('active')));
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.gridlist-toggle [data-type]')) {
      // Vendor delegated handlers update .active during this click.
      setTimeout(syncViews, 0);
    }
    const toggle = event.target.closest('.jm-category-toggle');
    if (toggle) {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.closest('.collection__category-seemore').classList.toggle('act', expanded);
    }
  });
  document.addEventListener('keydown', (event) => {
    const control = event.target.closest('.gridlist-toggle a[role="button"]');
    if (control && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      control.click();
    }
  });
  document.addEventListener('DOMContentLoaded', () => setTimeout(syncViews, 0), { once: true });
  window.addEventListener('load', syncViews, { once: true });
  syncViews();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('joy-footer')) {
    class JoyFooter extends HTMLElement {
      connectedCallback() {
        this.menus = Array.from(this.querySelectorAll('.jm-footer__menu'));
        this.desktopMedia = window.matchMedia('(min-width: 768px)');
        this.syncMenus = () => {
          this.menus.forEach((menu) => {
            menu.open = this.desktopMedia.matches;
          });
        };

        if (this.desktopMedia.addEventListener) {
          this.desktopMedia.addEventListener('change', this.syncMenus);
        } else {
          this.desktopMedia.addListener(this.syncMenus);
        }

        this.syncMenus();
      }

      disconnectedCallback() {
        if (!this.desktopMedia || !this.syncMenus) return;

        if (this.desktopMedia.removeEventListener) {
          this.desktopMedia.removeEventListener('change', this.syncMenus);
        } else {
          this.desktopMedia.removeListener(this.syncMenus);
        }
      }
    }

    customElements.define('joy-footer', JoyFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
